import ResetPasswordModal from '../component/auth/resetPasswordModal';

export const ResetPassword = () => {
  return (
    <div>
      <ResetPasswordModal />
    </div>
  );
};
